<template>
    <v-container fluid grid-list-md>
        <v-layout column wrap>
            <v-flex>
                <h1 class="display-3">Liberación crediticia de pedido</h1>
            </v-flex>
        </v-layout>
        <v-layout>
            <v-flex xs12 md4>
                <empresa-select v-model="empresa"></empresa-select>
            </v-flex>
            <v-flex xs12 md4>
                <v-text-field label="Pedido de venta" v-model="pedido"></v-text-field>
            </v-flex>
            <v-flex>
                <v-btn color="green" dark @click="procesar" :loading="loading">Procesar</v-btn>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
    import EmpresaSelect from "../../components/EmpresaSelect";
    import {mapActions} from "vuex";

    export default {
        name: "pedido_libera",
        components: {EmpresaSelect},
        data() {
            return {
                pedido: '',
                empresa: '',
                loading: false
            }
        },
        methods: {
            ...mapActions('notif', ['msjShow']),
            procesar() {
                this.loading = true;
                this.$http.post('varios/pedido-libera', {pedido: this.pedido, empresa: this.empresa})
                    .then(r => {
                        this.msjShow(r.data);
                        this.loading = false;
                    })
                    .catch(err => {
                        this.loading = false;
                    })
            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// resources/assets/js/pages/varios/pedido_libera.vue